import enviro from 'enviro';
import { SignupEmbedder, SignupEmbedderOptions } from 'signup-embedder';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { SignupDatapoint } from 'signup-ui-lego-core/constants/SignupDataPoint';
import { Intent } from 'signup-constants/Intent';
import { HubsTrackingAttr } from 'signup-constants/HubsTrackingAttr';
export function startSignupInPopup(id, chat, query) {
  const embedder = new SignupEmbedder().setOptions(new SignupEmbedderOptions().setShouldSkipPrefilledSteps()).setEnvironment(enviro.isProd() ? 'prod' : 'qa').addQueryParam(SignupQueryKeys.Intent, Intent.livechatBuilder).addQueryParam(query).setSignupData({
    [SignupDatapoint.CompanyDomain]: chat.companyDomain,
    [SignupDatapoint.CompanyName]: chat.companyName,
    [SignupDatapoint.FirstName]: chat.firstName,
    [SignupDatapoint.LastName]: chat.lastName
  });
  if (id) {
    embedder.addQueryParam('chatState', id);
  }
  embedder.asPopup();
}
export function startSignupInIframe(id, uuid, chat, query) {
  const embedder = new SignupEmbedder().setOptions(new SignupEmbedderOptions().setShouldSkipPrefilledSteps()).setOptions(new SignupEmbedderOptions().setDeviceId(uuid)).setEnvironment(enviro.isProd() ? 'prod' : 'qa').addQueryParam(SignupQueryKeys.Intent, Intent.livechatBuilder).addQueryParam(HubsTrackingAttr.SignupCta, 'crm-livechat-hero-variant').addQueryParam(query).setSignupData({
    [SignupDatapoint.CompanyDomain]: chat.companyDomain,
    [SignupDatapoint.CompanyName]: chat.companyName,
    [SignupDatapoint.FirstName]: chat.firstName,
    [SignupDatapoint.LastName]: chat.lastName
  });
  if (id) {
    embedder.addQueryParam('chatState', id);
  }
  embedder.addPostMessageListener('SIGNUP_REDIRECT_MESSAGE_TYPE', message => {
    window.location.href = message.url;
  });
  embedder.attachTo('#signup-embedded');
  const iframeContainer = document.getElementById('signup-embedded');
  if (iframeContainer) iframeContainer.classList.add('fullscreen-iframe');
}